import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { TimetableView } from './bulk/TimetableView';
import { AttachmentsGrid } from './AttachmentsGrid';
import { BulkUploadPromptGenerator } from './bulk/BulkUploadPromptGenerator';
import { EventBulkUpload } from './bulk/EventBulkUpload';
import { EventCalendar } from './EventCalendar';
import { EventCreate } from './EventCreate';
import { EventDisplay } from './EventDisplay';
import { EventEdit } from './EventEdit';
import { Four04 } from 'gossamer-front-end';
import { EventSearch } from './EventSearch';
import { HostEventSearch } from './HostEventSearch';
import { BulkUploadHistory } from './bulk/BulkUploadHistory';

export const EventRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/attachments-grid/:key" element={<AttachmentsGrid />} />
    <Route path="/bulk-upload" element={<EventBulkUpload />} />
    <Route path="/bulk-upload-history" element={<BulkUploadHistory />} />
    <Route path="/bulk-upload-prompt-gen" element={<BulkUploadPromptGenerator />} />
    <Route path="/calendar" element={<EventCalendar />} />
    <Route path="/create" element={<EventCreate />} />
    <Route path="/display/:key" element={<EventDisplay />} />
    <Route path="/edit/:key" element={<EventEdit />} />
    <Route path="/host-search" element={<HostEventSearch />} />
    <Route path="/search" element={<EventSearch />} />
    <Route path="/timetable" element={<TimetableView />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
